import { render } from "./recommendedBusinesses.vue?vue&type=template&id=0942c28d"
import script from "./recommendedBusinesses.vue?vue&type=script&lang=js"
export * from "./recommendedBusinesses.vue?vue&type=script&lang=js"

import "./recommendedBusinesses.vue?vue&type=style&index=0&id=0942c28d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__